import React,{useContext,useEffect, useState, useRef, useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import {  getRequest, postRequest } from '../../api/ApiController';
import { InfoIcon, ErrorIcon, TaskIcon, PermissionIcon, NeedIcon, EmergencyIcon, BellSlashIcon, DeleteIcon, OutlookMsgIcon, BorrowItemIcon, BotIcon, TechChangeIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { LocaleContext } from '../../components/LocaleContext';
import { confirmDialog } from 'primereact/confirmdialog';
import '../../assets/css/support.css';
import { Avatar } from 'primereact/avatar';
import { DateTime } from "luxon";
import parse from 'html-react-parser';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Tag } from 'primereact/tag';
import MyEditor from '../../components/Editor';
import { Skeleton } from 'primereact/skeleton';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Message } from 'primereact/message';
import { Calendar } from 'primereact/calendar';
import { Chips } from 'primereact/chips';
import { InputSwitch } from 'primereact/inputswitch';
import { addLocale } from 'primereact/api';
import TaskTableLauncher from '../../components/planner/TaskTableLauncher';
import { Checkbox } from 'primereact/checkbox';
import { MachineStateDot } from '../../components/StatusIndicator';
import { getPusherChannel } from '../../utils/pusherChannel';
import { resolveSystemI18nComment } from '../../utils/systemI18nComment';
import {
    buildServiceTaskSetExecutorFields,
    findUserByCanonicalExecutorId,
    getServiceTaskExecutorUiState,
    isCanonicalExecutor,
    pickUsersByCanonicalExecutorIds,
} from '../../utils/serviceTaskExecutors';

function buildPrimeReactCalendarLocale(calLocale, t) {
    const monthLongFmt = new Intl.DateTimeFormat(calLocale, { month: 'long', timeZone: 'UTC' });
    const monthShortFmt = new Intl.DateTimeFormat(calLocale, { month: 'short', timeZone: 'UTC' });
    const wdLongFmt = new Intl.DateTimeFormat(calLocale, { weekday: 'long', timeZone: 'UTC' });
    const wdShortFmt = new Intl.DateTimeFormat(calLocale, { weekday: 'short', timeZone: 'UTC' });
    const wdNarrowFmt = new Intl.DateTimeFormat(calLocale, { weekday: 'narrow', timeZone: 'UTC' });
    const sundayUtc = new Date(Date.UTC(2000, 0, 2));
    const dayNames = [];
    const dayNamesShort = [];
    const dayNamesMin = [];
    for (let i = 0; i < 7; i++) {
        const d = new Date(sundayUtc);
        d.setUTCDate(sundayUtc.getUTCDate() + i);
        dayNames.push(wdLongFmt.format(d));
        dayNamesShort.push(wdShortFmt.format(d));
        dayNamesMin.push(wdNarrowFmt.format(d));
    }
    const monthNames = [];
    const monthNamesShort = [];
    for (let m = 0; m < 12; m++) {
        const d = new Date(Date.UTC(2000, m, 1));
        monthNames.push(monthLongFmt.format(d));
        monthNamesShort.push(monthShortFmt.format(d));
    }
    return {
        firstDayOfWeek: 1,
        dayNames,
        dayNamesShort,
        dayNamesMin,
        monthNames,
        monthNamesShort,
        today: t('Common.Today'),
        clear: t('Common.Clear'),
        chooseDate: t('Common.ChooseDate'),
    };
}

export default function ServiceTaskDetail({ task = null, taskId: taskIdProp = null }) {

    const taskIdResolved = taskIdProp ?? task?.id;
    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {toast,getUserColor,getUserInitials,setDialogText,setVisible,openFilePreview,getDateFormat}= useContext(UtilContext);
    const { t, locale } = useContext(LocaleContext);
    const calendarLocale = locale === 'gb' ? 'en' : locale;
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const dateTimeFmt = `${dateFmt} HH:mm`;

    useEffect(() => {
        addLocale(calendarLocale, buildPrimeReactCalendarLocale(calendarLocale, t));
    }, [calendarLocale, t]);

    const [images,setImages] = useState(null);
    const [addedUser,setAddedUser] = useState([]);
    const [addedType,setAddedType] = useState("");
    const [showDetail,setShowDetail] = useState(false);
    const [showAddUser,setShowAddUser] = useState(false);

    const [recipientsReadMore,setRecipientsReadMore] = useState(false);

    const [formServiceTask, setFormServiceTask] = useState(task ?? null);
    const [loadingTask, setLoadingTask] = useState(() => {
        if (!taskIdResolved) return false;
        return !(task?.id != null && Number(task.id) === Number(taskIdResolved));
    });
    const [taskLoadError, setTaskLoadError] = useState(null);
    const currentTask = formServiceTask;

    const [executionSelect, setExecutionSelect] = useState(!["Info", "Emergency"].includes(task?.type) ? (task?.execution?.user_department || "") : "" );
    const [taskTableSummary, setTaskTableSummary] = useState(null);
    const [commentClick,setCommentClick] = useState(false);
    const [updatableComment,setUpdatableComment] = useState(0);

    const [involveTicket, setInvolveTicket] = useState(false);
    const [involveTargetType, setInvolveTargetType] = useState('');
    const [involveDepartment, setInvolveDepartment] = useState(null);
    const [involveUser, setInvolveUser] = useState(null);

    const [closeTab] = useState(false);
    const op = useRef(null);
    const scrollRef = useRef(null);
    /** Po našom POST (update/deadline/status...) nechceme hneď refetchovať z Pusheru – preskočíme GET ak sme aktualizovali pred <2s */
    const lastLocalUpdateAtRef = useRef(0);

    useEffect(() => {
        if (!taskIdResolved) return;
        setImages(null);
        const hasListSeed = task?.id != null && Number(task.id) === Number(taskIdResolved);
        if (!hasListSeed) {
            setLoadingTask(true);
        }
        getRequest(`/api/service_tasks/${taskIdResolved}`)
            .then((res) => {
                const data = res?.data ?? res;
                setFormServiceTask(data);
                setLoadingTask(false);
                scheduleAttachmentLoad(data?.id);
            })
            .catch((err) => {
                setTaskLoadError(err?.message || t('ServiceTaskDetail.LoadTicketFailed'));
                setLoadingTask(false);
            });
    }, [taskIdResolved, t, task?.id]);

    // Pusher: ak niekto iný upraví/vymaže tento tiket, obnov detail alebo zatvor tab
    useEffect(() => {
        if (!taskIdResolved) return;
        const channel = getPusherChannel();
        if (!channel) return;
        const onUpdated = (data) => {
            const taskId = data?.task_id ?? data?.task?.id;
            if (taskId == null || Number(taskId) !== Number(taskIdResolved)) return;
            if (Date.now() - lastLocalUpdateAtRef.current < 2000) return; // práve sme aktualizovali my (POST response už máme)
            getRequest(`/api/service_tasks/${taskIdResolved}`)
                .then((res) => {
                    const d = res?.data ?? res;
                    if (d) setFormServiceTask(d);
                })
                .catch(() => {});
        };
        const onDeleted = (data) => {
            const id = data?.id;
            if (id != null && Number(id) === Number(taskIdResolved)) {
                dispatch({ type: 'close_tab', id: state.selectedTab });
            }
        };
        channel.bind('service_task.updated', onUpdated);
        channel.bind('service_task.deleted', onDeleted);
        return () => {
            channel.unbind('service_task.updated', onUpdated);
            channel.unbind('service_task.deleted', onDeleted);
        };
    }, [taskIdResolved, dispatch, state.selectedTab]);

    useEffect(() => {
        if (!formServiceTask) return;
        const exec = formServiceTask?.execution?.user_department || "";
        setExecutionSelect(!["Info", "Emergency"].includes(formServiceTask?.type) ? exec : "");
    }, [formServiceTask?.id]);

    const [sortDescending, setSortDescending] = useState(true); // true = najnovšie navrchu

    var findedIds = [];

    function getImages(id=null){
        getRequest(`/api/service_tasks/images/${id ? id : formServiceTask?.id}`).then((response) => {
            //console.log(response);
            if (response.data !== "{}") setImages(response.data);
            else setImages([]);
        }).catch(() => setImages([]));
    }

    function scheduleAttachmentLoad(taskId) {
        if (!taskId) return;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => getImages(taskId));
        });
    }

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    useEffect(() => {
        if (scrollRef.current && !setSortDescending) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [formServiceTask?.comments?.length]);

    useEffect(() => {
        const taskExecution = currentTask?.execution || '{}';

        if (taskExecution?.user_department === "department") {
            setExecutionSelect("department");
        } else if (taskExecution?.user_department === "user") {
            setExecutionSelect("user");
        } else {
            setExecutionSelect(""); // fallback
        }
    }, [formServiceTask?.id]);

    const markAsViewed = async (taskId) => {
        let formData = new FormData();
        formData.append('task_id',taskId);
        formData.append('user_id',user.id);
        postRequest(`/api/service_tasks/${taskId}/mark-as-viewed`, formData,true)
        .then((response) => {
            dispatch({ type: 'updateTaskViewed', payload: taskId });
        }).catch((reason) => {
            //alert(t('Common.Toast.ActionFailedDetail'));
        });
    };

    useEffect(() => {
        // Ak je task neprečítaný, označ ho ako prečítaný pri načítaní detailu
        const idToMark = formServiceTask?.id ?? taskIdResolved;
        if (formServiceTask?.is_unread && idToMark) {
            markAsViewed(idToMark)
            .then(() => {
                dispatch({ type: 'updateTaskViewed', payload: idToMark });
            })
            .catch((error) => {
                //console.error('Nepodarilo sa označiť ako prečítané:', error);
            });
        }
    }, [formServiceTask?.id, formServiceTask?.is_unread, taskIdResolved]);

    const MACHINE_STATE_OPTIONS = useMemo(() => ([
        { value: 'in_fault', label: t('ServiceTask.MachineState.InFault') },
        { value: 'working_limited', label: t('ServiceTask.MachineState.WorkingLimited') },
        { value: 'functional', label: t('ServiceTask.MachineState.Functional') },
    ]), [t]);

    function isExecutionLockedByTaskTable() {
        if (!taskTableSummary) return false;
        return taskTableSummary.done !== true;
    }


    function onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
    }

    function loopThroughDOM(obj) {
        if(Array.isArray(obj)){
            for(let i=0;i<obj.length;i++){
                if(obj[i].hasOwnProperty("props") && obj[i].props.hasOwnProperty("children")){
                    loopThroughDOM(obj[i]["props"]["children"]);
                }
                if(obj[i].hasOwnProperty("props") && obj[i].props.hasOwnProperty("data-value")){
                    findedIds.push(obj[i]["props"]["data-id"]);
                }
            }
        }
        else{
            if (obj.hasOwnProperty("props") && obj.props.hasOwnProperty("children") && obj.props.children !== undefined) {
                loopThroughDOM(obj["props"]["children"]);
            }
            if(obj.hasOwnProperty("props") && obj.props.hasOwnProperty("data-value")){
                findedIds.push(obj["props"]["data-id"]);
            }
        }
    }

    const formik = useFormik({
        initialValues: {
            description:''
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.Saving'));
            setVisible(true);
            let formData = new FormData();
            for (let value in values) {
                if (value === "files") {
                    for(let i = 0;i<values[value].length;i++){
                        formData.append('files[]',values[value][i]);
                    }
                }
                else formData.append(value, values[value]);
            }
            formData.append('contractor_id',user.id);
            formData.append('task_id',formServiceTask?.id);
            let mentions = parse(values.description || "");
            loopThroughDOM(mentions);
            formData.append('mentions', findedIds.filter(onlyUnique));
            postRequest('/api/service_comments', formData,true)
            .then((response) => {
                const task = response?.data ?? response;
                if (task && (task.id || task.defined_id)) {
                    lastLocalUpdateAtRef.current = Date.now();
                    setFormServiceTask(task);
                    getImages(task.id);
                }
                if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                formik.resetForm();
                setCommentClick(false);
                findedIds = [];
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.RecordSaved') });
                setVisible(false);
            }).catch((reason) => {
                setVisible(false);
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('ServiceTask.ActionFailed'));
                }
            });
      },
    });

    const formikUpdate = useFormik({
        initialValues: {
            description:''
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
        setDialogText(t('Common.Saving'));
        setVisible(true);
          let formData = new FormData();
          for (let value in values) {
            if (value === "files") {
                for(let i = 0;i<values[value].length;i++){
                    formData.append('files[]',values[value][i]);
                }
            }
            else formData.append(value, values[value]);
          }
          let mentions = parse(values.description || "");
          loopThroughDOM(mentions);
          formData.append('mentions', findedIds.filter(onlyUnique));
          postRequest(`/api/service_comments/update/${formikUpdate.values.id}`, formData,true)
          .then((response) => {
              const task = response?.data ?? response;
              if (task && (task.id || task.defined_id)) {
                  lastLocalUpdateAtRef.current = Date.now();
                  setFormServiceTask(task);
                  getImages(task.id);
              }
              if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
              formikUpdate.resetForm();
              setUpdatableComment(false);
              findedIds = [];
              toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.CommentUpdated') });
              setVisible(false);
          }).catch((reason) => {
              setVisible(false);
              if(!navigator.online){
                  alert(t('ServiceTask.OfflineQueuedAlert'));
              }
              else{
                  alert(t('ServiceTask.ActionFailed'));
              }
          });
      },
    });

    const parseSendingData = () => {
        try {
            const r = formServiceTask?.sending_data;
            if (r == null || r === '' || r === 'undefined') return {};
            if (typeof r !== 'string') return {};
            return JSON.parse(r);
        } catch {
            return {};
        }
    };

    const formikTask = useFormik({
        initialValues: formServiceTask==null ? {
            theme:'',description:'',machine_id:'',machine_state:''
        }:{
            theme:formServiceTask?.theme,description: formServiceTask?.description,
            machine_id:{name:formServiceTask?.machine?.name || '',id:formServiceTask?.machine?.id || '',searchLabel: removeDiacritics(formServiceTask?.machine?.name)?.toLowerCase() || ''},
            machine_state: formServiceTask?.machine_state || ''
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
        setDialogText(t('Common.Saving'));
        setVisible(true);
          let formData = new FormData();
          formData.append("theme", values["theme"] != null ? values["theme"] : "");
          formData.append("description", values["description"] != null ? values["description"] : "");
          formData.append("machine_id", values["machine_id"] != null ? values["machine_id"]?.id : "");
          formData.append("machine_state", (currentTask?.type === 'Error' && values["machine_state"]) ? values["machine_state"] : "");
          postRequest(`/api/service_tasks/update/${formServiceTask?.id}`, formData,true)
          .then((response) => {
              if (response?.status === 200 && response?.data) {
                  lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                  if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                  formikTask.resetForm();
                  setShowDetail(false);
                  toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.TicketUpdated') });
              } else {
                  alert(response?.message || t('ServiceTask.ActionFailed'));
              }
              setVisible(false);
          }).catch((reason) => {
              setVisible(false);
              if(!navigator.online){
                  alert(t('ServiceTask.OfflineQueuedAlert'));
              }
              else{
                  alert(t('ServiceTask.ActionFailed'));
              }
          });
      },
    });

    useEffect(() => {
        if (formServiceTask && user) {
            setCanManagePlanner(canUserManagePlanner(formServiceTask));
        }

        if (formServiceTask) {
            const involvedUsers = formServiceTask?.mentions?.filter(m => m?.pivot?.involved) || [];
            const involvedDepts = formServiceTask?.departments?.filter(d => d?.pivot?.involved) || [];
            const hasInvolvedUser = involvedUsers.length > 0;
            const hasInvolvedDept = involvedDepts.length > 0;
            // checkbox – ak je aspoň 1 zapojený entity
            setInvolveTicket(hasInvolvedUser || hasInvolvedDept);
            const totalInvolved = involvedUsers.length + involvedDepts.length;
            // Ak je presne JEDEN zapojený (buď user alebo oddelenie), predvyplníme selecty
            if (totalInvolved === 1) {
                if (hasInvolvedDept) {
                    const dep = involvedDepts[0];
                    setInvolveTargetType('department');
                    setInvolveDepartment({id: dep.id,name: dep.name});
                    setInvolveUser(null);
                } else if (hasInvolvedUser) {
                    const u = involvedUsers[0];
                    setInvolveTargetType('user');
                    setInvolveUser({id: u.id,name: u?.employee?.name || u?.username});
                    setInvolveDepartment(null);
                }
            } else {
                // Viac zapojených (alebo žiadny) – checkbox necháme, ale selecty necháme prázdne
                setInvolveTargetType('');
                setInvolveDepartment(null);
                setInvolveUser(null);
            }
        }
    }, [formServiceTask, user]);

    function renderTicketType(type) {
        switch(type) {
            case 'Info':
                return <div className='flex gap-2 text-gray-800 items-center'><InfoIcon width={8} height={8}/><span>{t('ServiceTask.Type.Info')}</span></div>;
            case 'Error':
                return <div className='flex gap-2 text-gray-800 items-center'><ErrorIcon width={8} height={8}/><span>{t('ServiceTask.Type.Error')}</span></div>;
            case 'Task':
                return <div className='flex gap-2 text-gray-800 items-center'><TaskIcon width={8} height={8}/><span>{t('ServiceTask.Type.Task')}</span></div>;
            case 'Permission':
                return <div className='flex gap-2 text-gray-800 items-center'><PermissionIcon width={8} height={8}/><span>{t('ServiceTask.Type.Permission')}</span></div>;
            case 'Need':
                return <div className='flex gap-2 text-gray-800 items-center'><NeedIcon width={8} height={8}/><span>{t('ServiceTask.Type.Need')}</span></div>;
            case 'Borrow':
                return <div className='flex gap-2 text-gray-800 items-center'><BorrowItemIcon width={8} height={8}/><span>{t('ServiceTask.Type.Borrow')}</span></div>;
            case 'Emergency':
                return <div className='flex gap-2 text-gray-800 items-center'><EmergencyIcon width={8} height={8}/><span>{t('ServiceTask.Type.Emergency')}</span></div>;
            case 'TechChange':
                return <div className='flex gap-2 text-gray-800 items-center'><TechChangeIcon width={8} height={8}/><span>{t('ServiceTask.Type.TechChange')}</span></div>;
            default:
                return <div className='flex gap-2 text-gray-800 items-center'><InfoIcon width={8} height={8}/><span>{t('ServiceTask.Type.Info')}</span></div>;
        }
    }

    function renderTicketStatus(task) {
        if (!task) return null;
        let status = (state?.service_states ?? []).find(s => Number(s.id) === Number(task.status_id));
        if (!status) return null;
        if (status.phase === 'system_inspection') {
            const execStateId = task.execution?.executor_state;
            if (execStateId) {
                const execState = (state?.service_states ?? []).find(s => Number(s.id) === Number(execStateId));
                if (execState && execState.phase === 'execution' && execState.transition_type === 'non_final') {
                    status = execState;
                }
            } else {
                let fallbackState = null;
                if (task.execution?.user_department === "user") {
                    fallbackState = (state?.service_states ?? []).find(s => s.id === 9); // Pridelený
                } else if (task.execution?.user_department === "department") {
                    fallbackState = (state?.service_states ?? []).find(s => s.id === 10); // Pridelený oddeleniu
                } else {
                    fallbackState = (state?.service_states ?? []).find(s => s.id === 7); // Schválený
                }
                if (fallbackState) status = fallbackState;
            }
        }
        const color = status?.color ? `#${status.color}` : '#9ca3af'; // default gray
        return (
            <Tag style={{ backgroundColor: color }}>
                <span className="text-base font-normal">{status?.name}</span>
            </Tag>
        );
    }

    const accept = (id) => {
        getRequest(`/api/service_tasks/deleteImage/${id}`)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.FileDeleted') });
            getImages();
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Rejected'), detail: t('ServiceTaskDetail.Toast.FileDeleteFailed'), life: 3000 });
        })
    };

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Rejected'), detail: t('ServiceTask.Toast.RequestCancelled'), life: 3000 });
    }
    
    function deleteFiles(img){
        confirmDialog({
            message: t('ServiceTaskDetail.ConfirmDeleteFile'),
            header: t('ServiceTask.ConfirmDeleteTitle'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => accept(img.id)
        });
    }

    function checkNotification(){
        return currentTask?.mentions?.filter((mentioner) => Number(mentioner.id) === Number(user.id))[0]?.pivot?.notification;
    }

    function changeStatus(value){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();
        formData.append('status_id', value);
        postRequest(`/api/service_tasks/updateStatus/${formServiceTask?.id}`, formData,true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.TaskStatusUpdated')});
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    function changeNotification(){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();
        let value = Number(!checkNotification());
        formData.append('value', value);
        postRequest(`/api/service_tasks/updateNotification/${formServiceTask?.id}`, formData,true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: value ? t('ServiceTaskDetail.Toast.NotificationsOn') : t('ServiceTaskDetail.Toast.NotificationsOff')});
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    function addUser(typeOverride = null, mentionsOverride = null, involvedOverride = null){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();

        const effectiveMentions = mentionsOverride ?? addedUser;
        const effectiveType = typeOverride ?? addedType;
        const effectiveInvolved = !!involvedOverride;

        formData.append('mention', effectiveMentions?.map(obj => obj?.id) || '');
        formData.append('type', effectiveType);
        if (effectiveInvolved) {
            formData.append('involved', '1');   // ⬅️ ide na backend
        }

        postRequest(`/api/service_tasks/addUser/${formServiceTask?.id}`, formData,true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                const detail = effectiveType === "user" ? t('ServiceTaskDetail.Toast.UserAdded') : t('ServiceTaskDetail.Toast.DepartmentAdded');
                setAddedType("");
                setAddedUser([]);
                setShowAddUser(false);
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: detail});
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    function removeInvolved(type, targetId) {
        setDialogText(t('Common.Saving'));
        setVisible(true);
        const fd = new FormData();
        fd.append('type', type);
        fd.append('target_id', targetId);

        postRequest(`/api/service_tasks/removeInvolved/${formServiceTask?.id}`, fd, true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                toast?.current?.show({
                    severity: 'info',
                    summary: t('ServiceTask.Confirmed'),
                    detail: t('ServiceTaskDetail.Toast.InvolvementRemoved'),
                    life: 3000
                });
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        })
        .catch(() => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    function handleAddInvolvedToTicket() {
        if (!involveTicket) return;
        if (involveTargetType === "department" && involveDepartment) {
            addUser("department", [involveDepartment], true);  // true = involved
        } else if (involveTargetType === "user" && involveUser) {
            addUser("user", [involveUser], true);              // true = involved
        } else {
            return;
        }
        setInvolveTicket(false);
        setInvolveTargetType('');
        setInvolveDepartment(null);
        setInvolveUser(null);
    }

    // 🔎 aktuálne zapojený (ak je presne jeden)
    const involvedUsers = currentTask?.mentions?.filter(m => m?.pivot?.involved) || [];
    const involvedDepts = currentTask?.departments?.filter(d => d?.pivot?.involved) || [];
    const totalInvolved = involvedUsers.length + involvedDepts.length;

    const currentInvolved =
        totalInvolved === 1
            ? (involvedDepts.length === 1
                ? {
                    type: 'department',
                    id: involvedDepts[0].id,
                    name: involvedDepts[0].name,
                }
                : {
                    type: 'user',
                    id: involvedUsers[0].id,
                    name: involvedUsers[0]?.employee?.name || involvedUsers[0]?.username,
                })
            : null;

    const hasCurrentInvolved = !!currentInvolved;

     const canDisconnectInvolved = (type, targetId) => {
        const taskData = currentTask;
        if (!taskData || !user) return false;

        const userDeptId = user?.employee?.department_id ?? null;

        const mentionedUserIds =
            (taskData.mentions || []).map(m => String(m.id));
        const deptIds =
            (taskData.departments || []).map(d => String(d.id));

        // „zainteresovaný“ = je zakladateľ, alebo je v mentions, alebo je z niektorého z oddelení
        const isInterested =
            String(taskData.contractor_id) === String(user.id) ||
            mentionedUserIds.includes(String(user.id)) ||
            (userDeptId && deptIds.includes(String(userDeptId)));

        if (!isInterested) return false;

        // nesmie to byť práve ten zapojený
        if (type === 'user') {
            if (String(user.id) === String(targetId)) return false;
        } else if (type === 'department') {
            if (userDeptId && String(userDeptId) === String(targetId)) return false;
        }

        return true;
    };

    const handleInvolveButtonClick = () => {
        if (checkIfTaskIsCLosed(formServiceTask)) return;

        if (currentInvolved) {
            // 👉 odpojenie existujúceho
            removeInvolved(currentInvolved.type, currentInvolved.id);
        } else {
            // 👉 nové zapojenie
            handleAddInvolvedToTicket();
        }
    };


    function setApproverID(level_id,approver){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();
        formData.append('level_id', level_id);
        formData.append('approver_id', approver?.id);
        postRequest(`/api/service_tasks/setApprover/${formServiceTask?.id}`, formData,true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                setAddedType("");
                setAddedUser([]);
                setShowAddUser(false);
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.AssigneeSaved')});
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    function setApproverState(level_id,approval_state){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();
        formData.append('level_id', level_id);
        formData.append('approval_state', approval_state);
        postRequest(`/api/service_tasks/setApproverState/${formServiceTask?.id}`, formData,true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                setAddedType("");
                setAddedUser([]);
                setShowAddUser(false);
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.StateSaved')});
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    const weekTimePeriod = [
        {name: 'Pondelok'},
        {name: 'Utorok'},
        {name: 'Streda'},
        {name: 'Štvrtok'},
        {name: 'Piatok'},
        {name: 'Sobota'},
        {name: 'Nedeľa'},
    ];

    const monthTimePeriod = Array.from({length: 31}, (_, i) => i + 1).map((i) =>{
        return {name: ''+i};}
        
    )

    function content(rawDescription) {
        const resolved = resolveSystemI18nComment(rawDescription, t);
        const display = resolved.text ?? '';
        const inner = resolved.type === 'legacy' && String(display).includes('<')
            ? parse(String(display))
            : display;
        return <div className="flex align-items-center">
            <BotIcon/>
            <div className="ml-2">{inner}</div>
        </div>;
    }

    function getRole(role){
        switch(role) {
            case 'approval':
                return t('ServiceTaskDetail.Role.Approver');
            case 'execution':
                return t('ServiceTaskDetail.Role.Executor');
            case 'inspection':
                return t('ServiceTaskDetail.Role.Inspector');
            case 'management':
                return t('ServiceTaskDetail.Role.Manager');
            default:
                return "";
        }
    }

    /** Rovnaká množina ako stĺpec Vykonanie/Deadline (backend getAwaitingUser / awaiting_user). */
    function isCurrentUserInServiceTaskAwaitingUser(taskData) {
        if (!taskData || user?.id == null) return false;
        if (user?.role === 'admin' || user?.is_superuser) return true;
        const awaiting = taskData.awaiting_user;
        if (!Array.isArray(awaiting)) return false;
        return awaiting.some(u => Number(u?.id) === Number(user.id));
    }

    function checkApprover(level) {
        const taskData = currentTask;
        if (!taskData) return true;
        // Získame ID všetkých stavov typu "final_auto" = ukončujúce
        const finalStateIds = (state?.service_states ?? [])
            .filter(s => s.transition_type === "final_auto")
            .map(s => s.id);
        // ID stavov, ktoré označujú schválenie
        const approvedStateIds = (state?.service_states ?? [])
            .filter(s => s.phase === "approval" && s.transition_type === "section_final")
            .map(s => s.id);
        // Ak je task v ukončenom stave (napr. Uzavretý, Stornovaný)
        if (finalStateIds.includes(taskData.status_id)) return true;
        const approvalList = taskData.approval ?? [];
        const currentIndex = approvalList.findIndex(a => Number(a.level_id) === Number(level?.level_id));
        // Ak už má tento level pridelený stav
        if (level?.approval_state !== "") return true;
        // Ak predchádzajúci approval level nie je schválený
        if (currentIndex > 0) {
            const prevApproval = approvalList[currentIndex - 1];
            if (!approvedStateIds.includes(prevApproval?.approval_state)) return true;
        }
        return !isCurrentUserInServiceTaskAwaitingUser(taskData);
    }

    function isFinalStatus(state) {
        return state?.phase === "closing" && state?.transition_type === "final_auto";
    }

    function checkApproverState(level) {
        const taskData = currentTask;
        if (!taskData) return true;
        const status = (state?.service_states ?? []).find(s => Number(s.id) === Number(taskData?.status_id));
        const approvalState = (state?.service_states ?? []).find(s => Number(s.id) === Number(level?.approval_state));
        // Ak je tiket v uzatváracej fáze a je typu final
         if (isFinalStatus(status)) return true;
        // Ak nie je nastavený schvaľovateľ alebo ním nie je aktuálny používateľ
        if (!level?.approver_id || Number(user?.id) !== Number(level?.approver_id)) return true;
        // Ak je approval stav schválený (napr. podľa fázy schvaľovania a section_final typu)
        if (approvalState?.phase === "approval" && approvalState?.transition_type === "section_final") return true;
        // Inak môže meniť stav
        return false;
    }

    function checkClosureApproval() {
        const taskData = currentTask;
        if (!taskData) return true; // Ak neexistuje task, disable
        
        const rejectedId = (state?.service_states ?? []).find(s => s.phase === "approval" && s.transition_type === "final_manually")?.id;
        if (!rejectedId) return true; // fallback
        
        const approvalArray = taskData.approval || [];
        const index = approvalArray.findIndex(item => Number(item.approval_state) === Number(rejectedId));
        if (index !== -1) {
            const levels = approvalArray.slice(index).map(item => item.level_id);
            if (levels.length > 0) {
                const users = (state?.service_user_settings ?? [])
                    .filter(setting => levels.includes(setting.level_id))
                    .map(setting => setting.user_id)
                    .filter(Boolean);
                if (users.includes(user.id)) return false;
            }
        }
        return true;
    }

    function checkClosureExecution(){
        const taskData = currentTask;
        if (!taskData?.execution) return true;

        const stateId = parseInt(taskData.execution.executor_state);
        if (isNaN(stateId)) return true;

        const my_state = (state?.service_states ?? []).find(s => Number(s.id) === Number(stateId));
        if (!my_state) return true;
        
        return !(my_state.phase === "execution" && my_state.transition_type === "final_manually");
    };

    function checkClosureInspection() {
        const taskData = currentTask;
        if (!taskData) return true;

        const rejectedId = (state?.service_states ?? []).find(s => s.phase === "inspection" && s.transition_type === "final_manually")?.id;
        if (!rejectedId) return true;

        const inspectionArray = taskData.inspection || [];
        const index = inspectionArray.findIndex(item => Number(item.inspector_state) === Number(rejectedId));
        if (index !== -1) {
            const levels = inspectionArray.slice(index).map(item => item.level_id);
            if (levels.length > 0) {
                const users = (state?.service_user_settings ?? [])
                    .filter(setting => levels.includes(setting.level_id))
                    .map(setting => setting.user_id)
                    .filter(Boolean);
                if (users.includes(user.id)) return false;
            }
        }
        return true;
    }

    function isApprovalInProgress(state) {
        return state?.phase === "created" || (["approval","system_approval"].includes(state?.phase) && ["non_final","level_final"].includes(state?.transition_type))
    }

    const checkUserDepartment = () => {
        const taskData = currentTask;
        if (!taskData) return true;
        const taskType = taskData?.type || formServiceTask?.type;
        const status = (state?.service_states ?? []).find(s => Number(s.id) === Number(taskData?.status_id));
        const isMemberOfLevel = (levelId) => {
            const settings = (state?.service_user_settings ?? []).filter(setting => Number(setting.level_id) === Number(levelId));
            return settings.some(setting =>
                (setting.user_id && Number(setting.user_id) === Number(user?.id)) ||
                (setting.department_id && Number(setting.department_id) === Number(user?.employee?.department_id))
            );
        };
        // Uzavretý alebo stornovaný => zakázané
        if (isFinalStatus(status)) return true;
        // Ak ešte prebieha schvaľovanie a existuje approval => zakáž
        if (taskData?.approval?.length > 0 && isApprovalInProgress(status)) return true;
        // Ak existuje správca pre typ tiketu, výber vykonávateľa môže robiť iba správca.
        const managementLevels = (state?.service_levels ?? []).filter(
            lvl => lvl.type === taskType && lvl.task === "management"
        );
        if (managementLevels.length > 0) {
            const managementLevelIds = managementLevels.map(lvl => lvl.id);
            const hasConfiguredManager = (state?.service_user_settings ?? []).some(
                setting => managementLevelIds.includes(setting.level_id)
            );
            if (hasConfiguredManager) return !managementLevelIds.some(isMemberOfLevel);
        }
        // Fallback bez správcu: môžu schvaľovatelia pre daný typ.
        const approval_levels = (state?.service_levels ?? []).filter(
            lvl => lvl.type === taskType && lvl.task === "approval"
        );
        for (let approval_level of approval_levels) {
            if (isMemberOfLevel(approval_level?.id)) return false;
        }
        // Inak zablokuj
        return true;
    };

    const checkDepartmentExecute = (department_id) => {
        const taskData = currentTask;
        if (!taskData) return true;
        const taskType = taskData?.type || formServiceTask?.type;
        const status = (state?.service_states ?? []).find(s => Number(s.id) === Number(taskData?.status_id));
        const isMemberOfLevel = (levelId) => {
            const settings = (state?.service_user_settings ?? []).filter(setting => Number(setting.level_id) === Number(levelId));
            return settings.some(setting =>
                (setting?.user_id && Number(setting?.user_id) === Number(user?.id)) ||
                (setting?.department_id && Number(setting?.department_id) === Number(user?.employee?.department_id))
            );
        };
        // Ak je uzavretý alebo stornovaný => zablokuj
        if (isFinalStatus(status)) return true;
        // Ak prebieha schvaľovanie a sú definované schvaľovacie úrovne => zablokuj
        if (taskData?.approval?.length > 0 && isApprovalInProgress(status)) return true;
        // Ak existuje správca pre typ tiketu, výber vykonávateľa môže robiť iba správca.
        const managementLevels = (state?.service_levels ?? []).filter(
            lvl => lvl.type === taskType && lvl?.task === "management"
        );
        if (managementLevels.length > 0) {
            const managementLevelIds = managementLevels.map(lvl => lvl.id);
            const hasConfiguredManager = (state?.service_user_settings ?? []).some(
                setting => managementLevelIds.includes(setting.level_id)
            );
            if (hasConfiguredManager) return !managementLevelIds.some(isMemberOfLevel);
        }
        // Fallback bez správcu: môžu schvaľovatelia pre daný typ.
        const approval_levels = (state?.service_levels ?? []).filter(
            lvl => lvl.type === taskType && lvl?.task === "approval"
        );
        for (let approval_level of approval_levels) {
            if (isMemberOfLevel(approval_level?.id)) return false;
        }
        // Používateľ patrí do daného oddelenia => povolené
        const employee = (state?.employees ?? []).find(e => Number(e.id) === Number(user?.employee?.id));
        if (employee && Number(employee?.department_id) === Number(department_id)) return false;
        // Všetko ostatné zablokuj
        return true;
    };

    function isExecutionDone(state) {
        return state?.phase === "execution" && (state?.transition_type === "section_final" || state?.transition_type === "final_auto");
    }

    function checkExecutorState() {
        const taskData = currentTask;
        if (!taskData) return true;

        const status = (state?.service_states ?? []).find(s => Number(s.id) === Number(taskData?.status_id));
        const execution = taskData?.execution;
        const executorState = (state?.service_states ?? []).find(s => Number(s.id) === Number(execution?.executor_state));
        // Ak je task uzavretý alebo stornovaný => zablokuj
        if (isFinalStatus(status)) return true;
        // Ak je vykonanie hotové => zablokuj
        if (isExecutionDone(executorState)) return true;
        // Ak je používateľ aktuálnym kanonickým executorom => povoliť
        if (isCanonicalExecutor(execution, user?.id)) return false;
        // Inak zablokuj
        return true;
    }

    const checkInspector = (level) => {
        const taskData = currentTask;
        const status = (state?.service_states ?? []).find(s => Number(s.id) === Number(taskData?.status_id));
        // Ak nenájdem status, zablokujem
        if (!status) return true;
        // Ak je status vo fáze closing s prechodom final_auto alebo final_manually (uzavretý alebo stornovaný)
        if (["final_auto", "final_manually"].includes(status.transition_type)) return true;
        // Ak je už stav v inspector_state nastavený (neprázdny)
        if (level?.inspector_state != null && level?.inspector_state !== "") return true;
        // Ak je status vo fáze created alebo system (napr. čakanie na schválenie) zablokuj
        if (["created", "system_approval"].includes(status.phase)) return true;
        return !isCurrentUserInServiceTaskAwaitingUser(taskData);
    };

    function checkInspectorState(level) {
        const taskData = currentTask;
        const status = (state?.service_states ?? []).find(s => Number(s.id) === Number(taskData?.status_id));
        const inspectorState = (state?.service_states ?? []).find(s => Number(s.id) === Number(level?.inspector_state));
        // Ak nenájdem status, zablokujem
        if (!status) return true;
        // Uzavretý alebo Stornovaný task - podľa transition_type final_auto alebo final_manually je readonly
        if (isFinalStatus(status)) return true;
        // Ak je už stav Skontrolovaný (podľa typu fázy alebo názvu), tak zablokovať
        // Predpokladám, že "Skontrolovaný" môže mať špecifický phase alebo transition_type, ale ak nie, použijeme meno
        if (inspectorState?.phase === "inspection" && (inspectorState?.transition_type === "section_final" || inspectorState?.transition_type === "final_auto")) return true;
        // Ak je aktuálny užívateľ inšpektor
        if (Number(level?.inspector_id) === Number(user?.id)) return false;
        // Inak zablokované
        return true;
    }

    function setExecutor(select_type,executor){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();
        const fields = buildServiceTaskSetExecutorFields({
            selectType: select_type,
            executor,
            userDepartment: executionSelect,
            departmentId: currentTask?.execution?.department_id,
        });
        Object.keys(fields).forEach((key) => {
            formData.append(key, fields[key]);
        });
        postRequest(`/api/service_tasks/setExecutor/${formServiceTask?.id}`, formData,true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.AssigneeSaved')});
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    function setInspector(level_id,inspector){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();
        formData.append('level_id', level_id);
        formData.append('inspector_id', inspector?.id);
        postRequest(`/api/service_tasks/setInspector/${formServiceTask?.id}`, formData,true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.AssigneeSaved')});
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    function setExecutorState(value){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();
        formData.append('executor_state', value);
        postRequest(`/api/service_tasks/setExecutorState/${formServiceTask?.id}`, formData,true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.StateSaved')});
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    function formatDateToInput(date) {
        if (!date) return "";
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    function setExecutionDeadline(value){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();
        formData.append('execution_deadline', value ? formatDateToInput(value) : "");
        postRequest(`/api/service_tasks/setExecutionDeadline/${formServiceTask?.id}`, formData,true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.StateSaved')});
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    function updateMachineState(value){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        const formData = new FormData();
        formData.append('machine_state', value || '');
        postRequest(`/api/service_tasks/setMachineState/${formServiceTask?.id}`, formData, true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                formikTask.setFieldValue('machine_state', value);
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.MachineStateUpdated')});
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    function setInspectorState(level_id,value){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();
        formData.append('level_id', level_id);
        formData.append('inspector_state', value);
        postRequest(`/api/service_tasks/setInspectorState/${formServiceTask?.id}`, formData,true)
        .then((response) => {
            if (response?.status === 200 && response?.data) {
                lastLocalUpdateAtRef.current = Date.now();
                setFormServiceTask(response.data);
                  dispatch({ type: 'serviceTaskUpdatedInDetail', payload: response.data });
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.StateSaved')});
            } else {
                alert(response?.message || t('ServiceTask.ActionFailed'));
            }
            setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('ServiceTask.ActionFailed'));
        });
    }

    function removeDiacritics(str) {
        return str?.normalize('NFD')?.replace(/[\u0300-\u036f]/g, '');
    }

    const commentsList = currentTask?.comments ?? [];
    const lastAddedComment = commentsList.length === 0
        ? null
        : commentsList.reduce((latest, current) => {
            return new Date(current.created_at) > new Date(latest.created_at) ? current : latest;
        }, commentsList[0]);

    function checkIfTaskIsCLosed(task) {
        if (!task) return false;
        let status = task.status;
        if (!status) {
            const storeTask = currentTask;
            status = storeTask?.status || (state?.service_states ?? []).find(s => Number(s.id) === Number(storeTask?.status_id));
        }
        if (!status) return false;
        return status.phase === "closing" && status.transition_type === "final_auto";
    }

    const isUserInLevel = (levelId) => {
        const levelDef = (state?.service_levels ?? []).find(lvl => Number(lvl.id) === Number(levelId));
        if (!levelDef) return false;

        const settings = (state?.service_user_settings ?? []).filter(s => Number(s.level_id) === Number(levelDef.id));
        return settings.some(setting =>
            (setting.user_id && Number(setting.user_id) === Number(user?.id)) ||
            (!setting.user_id && Number(setting.department_id) === Number(user?.employee?.department_id))
        );
    };

    const isUserInManagementLevelForType = (taskType) => {
        if (!taskType) return false;
        const managementLevels = (state?.service_levels ?? []).filter(
            lvl => lvl.type === taskType && lvl.task === "management"
        );
        return managementLevels.some(level => isUserInLevel(level.id));
    };

    const canUserManagePlanner = (taskData) => {
        if (!taskData || !user) return false;
        return Number(user.id) === Number(taskData.contractor_id)
            || isUserInManagementLevelForType(taskData.type);
    };

    function isUserApproverOrManager(task, user) {
        const taskData = currentTask;
        if (!taskData) return false;

        // ID stavov, ktoré sú ukončujúce
        const finalStateIds = (state?.service_states ?? [])
            .filter(s => s.transition_type === "final_auto")
            .map(s => s.id);

        // Ak je task v ukončenom stave, už nemá zmysel overovať levely
        if (finalStateIds.includes(taskData.status_id)) return false;

        const approvalList = taskData.approval ?? [];
        // Overenie pre všetky approver levely
        for (let level of approvalList) {
            if (isUserInLevel(level.level_id)) {
                return true;
            }
        }

        // Overenie pre management levely (podľa typu tasku)
        const managementLevels = (state?.service_levels ?? []).filter(
            lvl => lvl.type === task?.type && lvl.task === "management"
        ) ?? [];

        for (let lvl of managementLevels) {
            if (isUserInLevel(lvl.id)) {
                return true;
            }
        }

        return false;
    }

    const [canManagePlanner, setCanManagePlanner] = useState(false);

    useEffect(() => {
        if (formServiceTask && user) {
            setCanManagePlanner(canUserManagePlanner(formServiceTask));
        }
        if (formServiceTask){
            const hasInvolvedUser = formServiceTask?.mentions?.some(m => m?.pivot?.involved);
            const hasInvolvedDept = formServiceTask?.departments?.some(d => d?.pivot?.involved);
            setInvolveTicket(!!(hasInvolvedUser || hasInvolvedDept));
        }
    }, [formServiceTask, user]);

    if (loadingTask) {
        return (
            <div className="relative flex flex-col bg-gray-100 w-full py-4 px-4">
                <div className="w-auto bg-white rounded-md shadow-md px-10 py-6">
                    <Skeleton height="2rem" className="mb-2" />
                    <Skeleton height="4rem" className="mb-2" />
                    <Skeleton height="12rem" />
                </div>
            </div>
        );
    }
    if (taskLoadError) {
        return (
            <div className="relative flex flex-col bg-gray-100 w-full py-4 px-4">
                <Message severity="error" text={taskLoadError} />
            </div>
        );
    }
    if (!formServiceTask) {
        return (
            <div className="relative flex flex-col bg-gray-100 w-full py-4 px-4">
                <Message severity="warn" text={t('ServiceTask.TicketNotFound')} />
            </div>
        );
    }

    const toExecutorOption = (executorUser) => (
        executorUser
            ? { name: executorUser?.employee?.name || executorUser?.username, id: executorUser.id }
            : ""
    );

    const renderCanonicalExecutorNames = (execution) => {
        const executors = pickUsersByCanonicalExecutorIds(state?.users ?? [], execution);
        return (
            <div className="mt-2 text-gray-800">
                <span className="font-semibold block mb-1">{t('ServiceTaskDetail.Executor')}:</span>
                {executors.length
                    ? executors.map(u => (
                        <div key={u.id} className="ml-1">
                            • {u?.employee?.name || u?.username}
                        </div>
                    ))
                    : <div className="text-gray-500">—</div>}
            </div>
        );
    };

return (
    <>
    <div className='relative flex flex-col bg-gray-100 w-full py-4 px-4 '>
    <div className='w-auto bg-white rounded-md shadow-md px-10 py-6 h-[calc(100vh_-_170px)]'>
    <div className='flex font-bold text-sm text-blue-800'>{t('ServiceTaskDetail.PortalBreadcrumb')} / {currentTask?.defined_id}</div>
    <div className='flex flex-row gap-11'>
        <div className='basis-2/3'>
          <div className='text-2xl font-light text-black py-6'>{currentTask?.theme}</div>
          <div className='flex flex-row justify-between items-center w-full p-4 border border-zinc-600 rounded-sm mb-2'>
            <div><Avatar className='p-overlay-badge' title={currentTask?.contractor?.employee?.name || currentTask?.contractor?.username} label={getUserInitials(currentTask?.contractor?.employee?.name || currentTask?.contractor?.username)} 
            shape="circle" style={{ backgroundColor: getUserColor(currentTask?.contractor?.username ?? ''), color: '#ffffff',marginRight: '5px'}}/>
            {currentTask?.contractor?.employee?.name || currentTask?.contractor?.username} {t('ServiceTaskDetail.CreatedBy')} {(Number(currentTask?.contractor?.employee?.id) !== Number(currentTask?.sender_id)) && <>{t('ServiceTaskDetail.ForUser')} {currentTask?.sender?.name} </>} {DateTime.fromISO(currentTask?.created_at).toFormat(dateFmt)}{t('Common.DateTimeAt')}{DateTime.fromISO(currentTask?.created_at).toFormat("HH:mm")}</div>
             <button onClick={() => {setFormServiceTask(currentTask);setShowDetail(true);}} className='font-semibold'>{t('ServiceTaskDetail.Detail')}</button>
          </div>
          <div className='max-h-[calc(100vh_-_450px)] overflow-y-auto flex-1 min-w-0'>
            <TaskTableLauncher
                serviceTaskId={formServiceTask?.id || task?.id}
                getRequest={getRequest}
                postRequest={postRequest}
                employees={state?.users ?? []}
                canManage={canManagePlanner}
                onSummaryChange={setTaskTableSummary}
                taskTheme={currentTask?.theme}
                taskDescription={currentTask?.description}
                taskSenderId={currentTask?.sender_id}
            />
            {currentTask?.type !== "Emergency" && <div>
            <div className='flex justify-between'>
                <h1 className='text-xl font-semibold text-black mb-4'>{t('ServiceTask.Activity')}</h1>
                <button onClick={() => setSortDescending(prev => !prev)} title={sortDescending ? t('ServiceTask.SortOldestFirst') : t('ServiceTask.SortNewestFirst')} className="text-gray-600 hover:text-gray-800">
                    <i className={`pi ${sortDescending ? 'pi-sort-amount-down' : 'pi-sort-amount-up'}`}></i>
                </button>
            </div>
            <div ref={scrollRef} className='h-fit overflow-y-auto'>
            {sortDescending && <div className='flex flex-row mb-3'>
                <div className='basis-1/10'>
                    <Avatar className='p-overlay-badge' title={user?.employee?.name || user?.username} label={getUserInitials(user?.employee?.name || user?.username)} shape="circle" style={{ backgroundColor: getUserColor(user?.username), color: '#ffffff',marginRight: '5px'}}/>
                </div>
                {!commentClick ? <div className='flex flex-col basis-9/10'>
                    <input 
                    type='text' onClick={() => {setCommentClick(true);}}
                    placeholder={t('ServiceTask.AddComment')}
                    className='app-activity-add-comment-input px-1 py-1 border focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                    />
                </div>:
                <form onSubmit={formik.handleSubmit}>
                    <div className="app-activity-comment-editor-border-wrap">
                    <MyEditor editorValue={formik.values.description} autofocus={true} fileAccept="*" formik={formik} activityMessageRadius={true} />
                    </div>
                    <div className='flex flex-row gap-1'>
                        <button typye="button" onClick={() => setCommentClick(false)} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-gray-600 rounded-md hover:bg-gray-400 focus:outline-none disabled:opacity-25'>{t('Common.Cancel')}</button>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>
                    </div>
                    </form>}
            </div>}
            {(currentTask?.comments ?? []).slice() // vytvorenie kópie, aby sme nemenili pôvodné pole
            .sort((a, b) => {
                return sortDescending
                ? b.id - a.id // najnovšie navrchu
                : a.id - b.id; // najstaršie navrchu
            }).map((comment, index, array) => 
            <div className='flex flex-row w-full justify-between mb-3'>
                <div className='basis-1/10'>
                    {comment?.by_system<2 ? <Avatar className='p-overlay-badge' title={comment.contractor?.employee?.name || comment.contractor?.username} label={getUserInitials(comment.contractor?.employee?.name || comment.contractor?.username)} shape="circle" style={{ backgroundColor: getUserColor(comment?.contractor?.username ?? ''), color: '#ffffff',marginRight: '5px'}}/>
                    :<Avatar className='p-overlay-badge' title={t('ServiceTask.SystemNotification')} icon="pi pi-database" shape="circle" style={{ backgroundColor: 'grey', color: '#ffffff',marginRight: '5px'}}/>}

                </div>
                <div className='flex flex-col grow basis-8/10 min-w-0'>
                    {comment?.by_system<2 ? <div className='mb-1'><span className='font-semibold'>{comment.contractor?.employee?.name || comment.contractor?.username}</span> {DateTime.fromISO(comment?.updated_at ?? '').toFormat(dateFmt)}{t('Common.DateTimeAt')}{DateTime.fromISO(comment?.updated_at ?? '').toFormat("HH:mm")}</div>:
                    <div className='mb-1'><span className='font-semibold'>{t('ServiceTask.SystemNotification')}</span> {DateTime.fromISO(comment?.updated_at ?? '').toFormat(dateFmt)}{t('Common.DateTimeAt')}{DateTime.fromISO(comment?.updated_at ?? '').toFormat("HH:mm")}</div>}
                    {comment?.by_system === 0 ? <div className="app-activity-comment-content min-w-0">{(lastAddedComment && Number(comment.id) === Number(lastAddedComment.id) && updatableComment) ?
                        <form onSubmit={formikUpdate.handleSubmit}>
                        <div className="app-activity-comment-editor-border-wrap">
                        <MyEditor editorValue={formikUpdate.description} autofocus={true} fileAccept="*" formik={formikUpdate} activityMessageRadius={true} />
                        </div>
                        <div className='flex flex-row gap-1'>
                        <button typye="button" onClick={() => setUpdatableComment(false)} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-gray-600 rounded-md hover:bg-gray-400 focus:outline-none disabled:opacity-25'>{t('Common.Cancel')}</button>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none disabled:opacity-25'>{t('Common.Edit')}</button>
                        </div>
                    </form> : <MyEditor editorValue={comment.description} hideToolbar={true} hideFileUpload={true} compact={true} formik={null} activityMessageRadius={true} />}{/*parse(comment.description || "")*/}
                    </div> : <Message severity="info" content={() => content(comment?.description)} className='app-activity-comment-content justify-start bg-gray-100' />}
                </div>
                {(lastAddedComment && Number(comment.id) === Number(lastAddedComment.id) && Number(comment.contractor_id) === Number(user.id) && currentTask?.status !== "Vyriešený" && comment?.by_system === 0) && 
                <div className='flex basis-1/10'>
                    {!updatableComment && <button  onClick={(e) => op.current.toggle(e)}><i className='pi pi-ellipsis-v'></i></button>}
                    <OverlayPanel ref={op}>
                        <div className='flex flex-col'>
                            <div className='flex flex-row items-center hover:bg-gray-200'>
                                <button className='px-4 py-3' onClick={(e) => {formikUpdate.setFieldValue('id',comment.id);formikUpdate.setFieldValue('description',comment.description);setUpdatableComment(true);op.current.toggle();}}><i className='pi pi-pencil mr-2'></i><span className='font-semibold'>{t('Common.Edit')}</span></button>
                            </div>
                            {/*<div className='flex flex-row items-center p-4 pt-2 hover:bg-gray-200'>
                                <button><i className='pi pi-trash mr-2'></i><span className='font-semibold'>{t('Common.Clear')}</span></button>
                            </div>*/}
                        </div>
                    </OverlayPanel>
                </div>}
            </div>)}
            {!sortDescending && <div className='flex flex-row mt-3'>
                <div className='basis-1/10'>
                    <Avatar className='p-overlay-badge' title={user?.employee?.name || user?.username} label={getUserInitials(user?.employee?.name || user?.username)} shape="circle" style={{ backgroundColor: getUserColor(user?.username), color: '#ffffff',marginRight: '5px'}}/>
                </div>
                {!commentClick ? <div className='flex flex-col basis-9/10'>
                    <input 
                    type='text' onClick={() => {setCommentClick(true);}}
                    placeholder={t('ServiceTask.AddComment')}
                    className='app-activity-add-comment-input px-1 py-1 border focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                    />
                </div>:
                <form onSubmit={formik.handleSubmit}>
                    <div className="app-activity-comment-editor-border-wrap">
                    <MyEditor editorValue={formik.values.description} autofocus={true} fileAccept="*" formik={formik} activityMessageRadius={true} />
                    </div>
                    <div className='flex flex-row gap-1'>
                        <button typye="button" onClick={() => setCommentClick(false)} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-gray-600 rounded-md hover:bg-gray-400 focus:outline-none disabled:opacity-25'>{t('Common.Cancel')}</button>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>
                    </div>
                    </form>}
            </div>}
            </div>
            </div>}
            {images === null && <Skeleton height="4rem" className="mb-2"></Skeleton>}
            {images?.length>0 && <div>
                <h2 className='text-xl'>{t('ServiceTask.Attachments')}</h2>
                <div className='flex flex-row flex-wrap w-full h-full border border-separate border-gray-400 rounded-md bg-white mb-4'>
                {images.map((img) => {
                    let extension = img.filename.split('.').pop();
                    if (extension === "msg") {
                        return <>
                        <div className='text-black h-auto w-52'><div className='flex flex-row p-2'>
                            <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>
                                <OutlookMsgIcon/>
                            </div>
                                <div className='flex flex-col ml-4'>
                                <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                                {user.role === "admin" && <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/></button>}
                                </div>
                            </div>
                        </div></>;
                    }                                  
                    return <>
                    <div className='text-black h-auto w-52'><div className='flex flex-row p-2'>
                        <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>
                            <embed src={img.url+'#page=1&view=FitH&scrollbar=0'} width='100px' height='auto'></embed>
                        </div>
                            <div className='flex flex-col ml-4'>
                            <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                            {user.role === "admin" && <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/></button>}
                            </div>
                        </div>
                    </div></>;
                })}
            </div>
            </div>}
          </div>
        </div>
        <div className='basis-1/3 h-[calc(100vh_-_270px)] overflow-y-auto overflow-x-hidden'>
          <div className='flex flex-col mb-3'>
            <label className='font-bold mb-0'>{t('ServiceTaskTable.Col.Status')}</label>
            <div className='text-gray-800 mb-3'>
            {user.role !== "admin"
                ? renderTicketStatus(currentTask)
                : <select
                    value={currentTask?.status_id}
                    onChange={(e) => changeStatus(parseInt(e.target.value))}
                    className='block w-60  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                    {(state?.service_states ?? [])
                    .filter(s => (s.applicable_types ?? []).includes(formServiceTask?.type))
                    .map(state => (
                        <option key={state.id} value={state.id}>{state.name}</option>
                    ))}
                </select>
            }
            </div>
            <div className='flex flex-col mb-3'>
            <label className='font-bold mb-1'>{t('ServiceTask.TicketType')}</label>
            <div className='flex flex-col items-start gap-2'>
                {renderTicketType(currentTask?.type)}
                {currentTask?.type === 'Error' && (
                    <span className='flex items-center gap-2 text-base text-gray-600 ml-2 my-2'>
                        <MachineStateDot task={currentTask} />
                        <span>{MACHINE_STATE_OPTIONS.find(o => o.value === currentTask?.machine_state)?.label || t('Common.Dash')}</span>
                    </span>
                )}
            </div>
            </div>
        </div>
          {(["Info","Emergency"].includes(currentTask?.type)) &&<div className='mb-3'>
            {currentTask?.type === "Info" ? <span className='text-gray-800'>{t('ServiceTaskDetail.LastSent')}: {currentTask?.last_sent ? DateTime.fromSQL(currentTask?.last_sent).toFormat(dateTimeFmt) : t('ServiceTaskDetail.NoSendRecord')}</span> : <span className='text-gray-800'>{t('ServiceTaskDetail.Sent')}: {currentTask?.last_sent ? DateTime.fromSQL(currentTask?.last_sent).toFormat(dateTimeFmt) : t('ServiceTaskDetail.NoSendRecord')}</span>}
          </div>}
          {currentTask?.type === "Emergency" && <div className='mb-3'>
            <span className='text-gray-800'>{t('ServiceTaskDetail.EmergencySentToAll')}</span>
          </div>}
          <div className='mb-3'>
            <button className="flex flex-row gap-2 disabled:opacity-25" onClick={() => changeNotification()} disabled={(currentTask?.status?.phase === "closing" && currentTask?.status?.transition_type === "final_auto")}>
                {currentTask?.mentions?.filter((mentioner) => Number(mentioner.id) === Number(user.id))[0]?.pivot?.notification ? <BellSlashIcon/> : <i title={t('ServiceTask.Notifications')} className="pi pi-bell" style={{ fontSize: '1.4rem', marginRight:5 }}></i>}
                <span className='text-gray-800'>{currentTask?.mentions?.filter((mentioner) => Number(mentioner.id) === Number(user.id))[0]?.pivot?.notification ? t('ServiceTaskDetail.TurnOffNotifications') : t('ServiceTaskDetail.TurnOnNotifications')}</span>
            </button>
          </div>
          <div className='mb-3'>
            <button type="button" className='flex flex-row gap-2 disabled:opacity-25' disabled={Number(user.id) !== Number(currentTask?.contractor_id) || Number(currentTask?.status_id) === 28} onClick={() => changeStatus(30)}>
                <i title={t('ServiceTaskDetail.StornoTicket')} className="pi pi-ban" style={{ fontSize: '1.4rem', marginRight:5 }}></i>
                <span className='text-gray-800'>{t('ServiceTaskDetail.StornoTicket')}</span>
            </button>
          </div>
          {!(["Info","Emergency"].includes(currentTask?.type)) &&<div className='mb-3'>
            <button type="button" className='flex flex-row gap-2 disabled:opacity-25' disabled={!(currentTask?.status?.phase === "closing" && currentTask?.status?.transition_type === "final_auto")} onClick={() => changeStatus(31)}>
                <i title={t('ServiceTask.Reopen')} className="pi pi-replay" style={{ fontSize: '1.4rem', marginRight:5 }}></i>
                <span className='text-gray-800'>{t('ServiceTask.Reopen')}</span>
            </button>
          </div>}
          {currentTask?.type === 'Error' && (
          <div className='mb-3'>
            <label className='font-bold mb-1 block'>{t('ServiceTask.MachineState')}</label>
            {(Number(formServiceTask?.contractor_id) === Number(user?.id) || isUserApproverOrManager(formServiceTask, user)) && !checkIfTaskIsCLosed(formServiceTask) ?
            <Dropdown value={formServiceTask?.machine_state || ''} onChange={(e) => updateMachineState(e.value)}
                options={MACHINE_STATE_OPTIONS}
                optionLabel="label"
                optionValue="value"
                placeholder={t('ServiceStateAdd.SelectStateType')} className="w-60 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
            : <span className='text-gray-800'>{MACHINE_STATE_OPTIONS.find(o => o.value === currentTask?.machine_state)?.label || t('Common.Dash')}</span>
            }
          </div>
          )}
          {currentTask?.approval?.map(level => {
    return (
    <div key={level.level_id} className='flex flex-col mt-2 mb-5'>
        <label className='font-bold mb-1'>
            {t('ServiceTaskDetail.Approval')} - {(state?.service_levels ?? []).find(lvl => Number(lvl.id) === Number(level.level_id))?.name}
        </label>
        <label className='font-normal text-md mb-1'>
            {t('ServiceTask.WaitingForApproval')}
        </label>
        <Dropdown 
            value={(state?.users ?? []).filter(user => Number(user.id) === Number(level?.approver_id)).map((user) => 
                    ({name:user?.employee?.name || user?.username,id:user.id})
                )[0] || ""}
            onChange={(e) => setApproverID(level?.level_id,e.value)} 
            options={(state?.users ?? []).filter(user => level?.possible_approvers?.includes(user?.id)).map((user) => 
                ({name:user?.employee?.name || user?.username,id:user.id})
            )} 
            optionLabel="name"
            disabled={checkApprover(level)}
            filter placeholder={t('ServiceTaskDetail.SelectEmployee')}
            className="w-60 px-2 py-0 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
        />
            <div className='mt-2'>
                <label className='font-normal text-md mb-1'>{t('ServiceTask.StatusLabel')}</label>
                <select
                    name="approval_state"
                    value={level?.approval_state}
                    onChange={(e) => setApproverState(level?.level_id, parseInt(e.target.value))}
                    disabled={checkApproverState(level)}
                    className="block w-60 px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                >
                    <option disabled value="">{t('Common.SelectOption')}</option>
                        {(state?.service_states ?? [])
                            .filter(s => s.phase === "approval")
                            .map(state => (
                                <option key={state.id} value={state.id}>{state.name}</option>
                            ))}
                </select>
                {(state?.service_states ?? []).filter(s => s.phase === "approval" && s.transition_type === "final_manually").some(s => s.id === formServiceTask?.status_id) && 
                    <button
                        disabled={checkClosureApproval()}
                        onClick={() => changeStatus((state?.service_states ?? []).find(s => s.name === "Uzavretý")?.id)}
                        type="button"
                        className='flex justify-center items-center mt-4 w-60 h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>
                        {t('ServiceTaskDetail.Close')}
                    </button>
                }
                </div>
            </div>
            )})}
            {!(["Info","Emergency"].includes(currentTask?.type)) && (
                <>
                {/* Zapojiť do tiketu */}
                <div className='mb-3'>
                    <label className='font-bold mb-1'>{t('ServiceTaskDetail.InvolveInTicket')}</label>
                    <div className='flex flex-col'>
                    <div className='flex items-center mb-2'>
                        <Checkbox
                        inputId="involveTicket"
                        checked={involveTicket}
                        onChange={(e) => setInvolveTicket(e.checked)}
                        disabled={checkIfTaskIsCLosed(formServiceTask)}
                        className="mr-2"
                        />
                        <label htmlFor="involveTicket" className="font-normal text-md">
                        {t('ServiceTaskDetail.InvolveAdditional')}
                        </label>
                    </div>
                    {involveTicket && (
                        <>
                        <label className='font-normal text-md mb-1'>{t('ServiceTaskDetail.DepartmentOrEmployee')}</label>
                        <select
                            name='involve_target'
                            value={involveTargetType}
                            onChange={(e) => {
                            setInvolveTargetType(e.target.value);
                            setInvolveDepartment(null);
                            setInvolveUser(null);
                            }}
                            disabled={checkIfTaskIsCLosed(formServiceTask) || hasCurrentInvolved}
                            className="bg-white block w-60 px-4 py-2 mt-2 mb-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                            <option value="">{t('Common.SelectOption')}</option>
                            <option value="department">{t('Common.Department')}</option>
                            <option value="user">{t('Common.Employee')}</option>
                        </select>
                        {involveTargetType === "department" && (
                            <Dropdown
                            value={involveDepartment}
                            onChange={(e) => setInvolveDepartment(e.value)}
                            options={(state.departments || []).map(dep => ({ name: dep.name, id: dep.id }))}
                            optionLabel="name"
                            filter
                            placeholder={t('ServiceTaskDetail.SelectDepartment')}
                            disabled={checkIfTaskIsCLosed(formServiceTask) || hasCurrentInvolved}
                            className="w-60 px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        )}
                        {involveTargetType === "user" && (
                            <Dropdown
                            value={involveUser}
                            onChange={(e) => setInvolveUser(e.value)}
                            options={(state.users || []).map(user => ({
                                name: user?.employee?.name || user?.username,
                                id: user.id,
                            }))}
                            optionLabel="name"
                            filter
                            placeholder={t('ServiceTaskDetail.SelectUser')}
                            disabled={checkIfTaskIsCLosed(formServiceTask) || hasCurrentInvolved}
                            className="w-60 px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        )}
                        {hasCurrentInvolved && (
                            <div className="mt-2 text-sm text-emerald-700">
                            {t('ServiceTaskDetail.CurrentlyInvolved')}: <span className="font-semibold">{currentInvolved.name}</span>
                            </div>
                        )}
                        <button
                            type="button"
                            onClick={handleInvolveButtonClick}
                            disabled={
                                checkIfTaskIsCLosed(formServiceTask) ||
                                (hasCurrentInvolved && !canDisconnectInvolved(currentInvolved.type, currentInvolved.id)) ||
                                (!hasCurrentInvolved && (
                                    !involveTargetType ||
                                    (involveTargetType === "department" && !involveDepartment) ||
                                    (involveTargetType === "user" && !involveUser)
                                ))
                            }
                            className='flex justify-center items-center mt-3 w-60 h-9 font-medium px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'
                        >
                            {hasCurrentInvolved ? t('ServiceTaskDetail.Disconnect') : t('ServiceTaskDetail.Involve')}
                        </button>
                        </>
                    )}
                    </div>
                </div>
                </>
            )}
          {!(["Info","Emergency"].includes(currentTask?.type)) && (
            <div className='mb-3'>
                <label className='font-bold mb-1'>{t('ServiceTaskDetail.Execution')}:</label>
                <div className='flex flex-col'>
                <label className='font-normal text-md mb-1'>{t('ServiceTaskDetail.DepartmentOrEmployee')}</label>
                <select 
                    name='user_department'
                    onChange={(e) => setExecutionSelect(e.target.value)}
                    disabled={checkUserDepartment() || isExecutionLockedByTaskTable()}
                    value={executionSelect}
                    className="bg-white block w-60 px-4 py-2 mt-2 mb-1 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                >
                    <option value="">{t('Common.SelectOption')}</option>
                    <option value="department">{t('Common.Department')}</option>
                    <option value="user">{t('Common.Employee')}</option>
                </select>

                {executionSelect === "department" && (
                    <Dropdown
                        disabled={checkUserDepartment() || isExecutionLockedByTaskTable()}
                        value={(state?.departments ?? []).filter(dep => Number(dep.id) === Number(currentTask?.execution?.department_id)).map(dep => ({ name: dep.name, id: dep.id }))[0] || ""}
                        onChange={(e) => setExecutor("department", e.value)}
                        options={(state?.departments ?? [])
                            .filter(department =>
                                !(state?.service_user_settings ?? [])
                                    .filter(setting => Number(setting.level_id) === Number(formik.values.level_id))
                                    .map(setting => setting.department_id)
                                    .includes(department.id)
                            )
                            .map(department => ({ name: department.name, id: department.id }))
                        }
                        optionLabel="name"
                        filter
                        placeholder={t('ServiceTaskDetail.SelectDepartments')}
                        className="w-60 px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                )}

                {executionSelect === "department" && currentTask?.execution?.department_id && (() => {
                    const execution = currentTask?.execution || {};
                    const ui = getServiceTaskExecutorUiState(execution);
                    if (ui.isReadOnly) {
                        return renderCanonicalExecutorNames(execution);
                    }
                    const selected = toExecutorOption(findUserByCanonicalExecutorId(state?.users ?? [], execution));
                    return (
                        <Dropdown
                        disabled={checkDepartmentExecute(currentTask?.execution?.department_id) || isExecutionLockedByTaskTable()}
                        value={selected}
                        onChange={(e) => setExecutor("user_department", e.value)}
                        options={(state?.users ?? [])
                            .filter(user => Number(user?.employee?.department_id) === Number(currentTask?.execution?.department_id))
                            .map(user => ({ name: user?.employee?.name || user?.username, id: user.id }))}
                        optionLabel="name"
                        filter
                        placeholder={t('ServiceUsersSettings.SelectUsers')}
                        className="w-60 px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                    );
                })()}

                {executionSelect === "user" && (() => {
                    const execution = currentTask?.execution || {};
                    const ui = getServiceTaskExecutorUiState(execution);

                    if (ui.isReadOnly || isExecutionLockedByTaskTable()) {
                        return renderCanonicalExecutorNames(execution);
                    }

                    const selected = toExecutorOption(findUserByCanonicalExecutorId(state?.users ?? [], execution));

                    return (
                        <Dropdown
                        disabled={checkUserDepartment() || isExecutionLockedByTaskTable()}
                        value={selected}
                        onChange={(e) => setExecutor("user", e.value)}
                        options={(state?.users ?? []).map(u => ({ name: u?.employee?.name || u?.username, id: u.id }))}
                        optionLabel="name"
                        filter
                        placeholder={t('ServiceTaskDetail.SelectUser')}
                        className="w-60 px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                    );
                })()}

                {getServiceTaskExecutorUiState(currentTask?.execution).hasExecutor && (
                    <div className='flex flex-col'>
                        <div>
                            <label className='font-normal text-md mb-1'>{t('ServiceTask.StatusLabel')}</label>
                            {isExecutionLockedByTaskTable() && <span className='font-bold ml-1'>- {t('ServiceTaskDetail.ByPlanner')}</span>}
                        </div>
                    <select
                        name="executor_state"
                        disabled={checkExecutorState() || isExecutionLockedByTaskTable()}
                        value={currentTask?.execution?.executor_state || ""}
                        onChange={(e) => setExecutorState(parseInt(e.target.value))}
                        className="block w-60 px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    >
                        <option disabled value="">{t('Common.SelectOption')}</option>
                        {(state?.service_states ?? [])
                        .filter(state => state.phase === "execution" && (state.applicable_types ?? []).includes(formServiceTask?.type))
                        .map(state => (
                            <option key={state.id} value={state.id}>{state.name}</option>
                        ))}
                    </select>
                    {(state?.service_states ?? []).filter(s => s.phase === "execution" && s.transition_type === "final_manually").some(s => s.id === formServiceTask?.status_id) && 
                        <button
                            disabled={checkClosureExecution()}
                            onClick={() => changeStatus((state?.service_states ?? []).find(s => s.name === "Uzavretý")?.id)}
                            type="button"
                            className="flex justify-center items-center mt-4 w-60 h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25">
                            {t('ServiceTaskDetail.Close')}
                        </button>
                    }
                    </div>
                )}
                </div>
            </div>
            )}
          {!(["Info", "Emergency"].includes(currentTask?.type)) && (
            <div className='mb-1'>
                {currentTask?.inspection?.map(level => {
                return (
                    <div key={level.level_id} className='flex flex-col mb-3'>
                    <label className='font-bold mb-1'>
                        {t('ServiceTaskDetail.Inspection')} - {(state?.service_levels ?? []).find(lvl => Number(lvl.id) === Number(level.level_id))?.name}
                    </label>
                    <label className='font-normal text-md mb-1'>
                        {t('ServiceTask.Status.WaitingInspection')}
                    </label>

                    <Dropdown
                        value={(state?.users ?? []).filter(user => Number(user.id) === Number(level?.inspector_id)).map(user => ({ name: user?.employee?.name || user?.username, id: user.id }))[0] || ""}
                        onChange={(e) => setInspector(level?.level_id, e.value)}
                        options={(state?.users ?? [])
                        .filter(user => level?.possible_inspectors?.includes(user?.id))
                        .map(user => ({ name: user?.employee?.name || user?.username, id: user.id }))}
                        optionLabel="name"
                        disabled={checkInspector(level)}
                        filter
                        placeholder={t('ServiceTaskDetail.SelectEmployee')}
                        className="w-60 px-2 py-0 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />

                    <div className='mt-2'>
                        <label className='font-normal text-md mb-1'>{t('ServiceTask.StatusLabel')}</label>
                        <select
                        name="inspector_state"
                        disabled={checkInspectorState(level)}
                        value={level?.inspector_state}
                        onChange={(e) => setInspectorState(level?.level_id, parseInt(e.target.value))}
                        className="block w-60 px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        <option disabled value="">{t('Common.SelectOption')}</option>
                        {(state?.service_states ?? [])
                            .filter(s => s.phase === "inspection" && (s.applicable_types ?? []).includes(formServiceTask?.type))
                            .map(state => (
                            <option key={state.id} value={state.id}>{state.name}</option>
                            ))}
                        </select>
                        {(state?.service_states ?? []).filter(s => s.phase === "inspection" && s.transition_type === "final_manually").some(s => s.id === formServiceTask?.status_id) && 
                            <button
                                disabled={checkClosureInspection()}
                                onClick={() => changeStatus((state?.service_states ?? []).find(s => s.name === "Uzavretý")?.id)}
                                type="button"
                                className='flex justify-center items-center mt-4 w-60 h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>
                                {t('ServiceTaskDetail.Close')}
                            </button>
                        }
                    </div>
                    </div>
                );
                })}
            </div>
            )}
        {!(["Info", "Emergency"].includes(currentTask?.type)) && (<div className='flex flex-col mb-5'>
                <label className='font-bold mb-1'>{t('ServiceTaskTable.Col.Deadline')}</label>
                <Calendar disabled={!isUserApproverOrManager(formServiceTask,user)} id="buttondisplay" name="dates" style={{border: '1px solid #e5e7eb',transition: 'background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s',borderRadius: '6px'}} 
                value={currentTask
                    ?.deadline
                    ? new Date(formServiceTask?.deadline)
                    : null} 
                onChange={(e) => setExecutionDeadline(e.value)} showIcon className="w-60" dateFormat="dd.mm.yy" firstDayOfWeek={1} locale={calendarLocale} />
            </div>)}
          <div className='flex flex-col mb-5'><label className='font-bold mb-1'>{t('ServiceTaskDetail.InterestedDepartments')}</label>
          {(currentTask?.departments ?? []).map(department => 
                <div className='flex items-center gap-2 text-gray-800 mb-2' key={department.id}>
                    <Avatar className='p-overlay-badge' title={department.name} label={getUserInitials(department.name)} shape="circle" style={{ backgroundColor: getUserColor(department.name), color: '#ffffff',marginRight: '5px'}}/>
                    <div className='flex flex-col flex-1'>
                        <span>{department.name}</span>
                        {department?.pivot && Number(department?.pivot?.involved) === 1 && (
                            <span className='text-sm text-emerald-700'>{t('ServiceTaskDetail.InvolvedInTicket')}</span>
                        )}
                    </div>
                    {/*department.pivot?.involved && !checkIfTaskIsCLosed(formServiceTask) && (
                        <button
                            type="button"
                            onClick={() => removeInvolved('department', department.id)}
                            className="text-xs text-red-600 hover:underline"
                        >{t('Ui.R67.Disconnect')}</button>
                    )*/}
                </div>
          )}
          <div className='text-gray-800'>
            <button type="button" onClick={() => {setAddedType("department");setShowAddUser(true);}} className='flex items-center gap-2 disabled:opacity-25' disabled={currentTask?.status?.phase === "closing" && currentTask?.status?.transition_type === "final_auto"}>
                <i className='pi pi-plus mr-2 px-1' style={{fontSize:"1.5rem"}}></i>{t('ServiceTaskDetail.AddDepartment')}
            </button>
          </div>
          </div>
          <div className='flex flex-col mb-5'><label className='font-bold mb-1'>{t('ServiceTaskDetail.InterestedUsers')}</label>
          {(currentTask?.mentions ?? []).map(user => 
                <div className='flex items-center gap-2 text-gray-800 mb-2' key={user.id}>
                    <Avatar className='p-overlay-badge' title={user?.employee?.name || user?.username} label={getUserInitials(user?.employee?.name || user?.username)} shape="circle" style={{ backgroundColor: getUserColor(user?.username ?? ''), color: '#ffffff',marginRight: '5px'}}/>
                    <div className='flex flex-col'>
                        <span>{user?.employee?.name || user?.username}</span>
                        {Number(currentTask?.contractor_id) === Number(user.id) && <span className='text-sm text-gray-500'>{t('ServiceTaskDetail.Founder')}</span>}
                        {user?.pivot?.role && <span className='text-sm text-gray-500'>{getRole(user?.pivot?.role)}</span>}
                        <div className='flex flex-col flex-1'>
                            {user?.pivot && Number(user?.pivot?.involved) === 1 && (
                                <span className='text-sm text-emerald-700'>{t('ServiceTaskDetail.InvolvedInTicket')}</span>
                            )}
                        </div>
                        {/*user.pivot?.involved && !checkIfTaskIsCLosed(formServiceTask) && (
                            <button
                                type="button"
                                onClick={() => removeInvolved('user', user.id)}
                                className="text-xs text-red-600 hover:underline"
                            >{t('Ui.R67.Disconnect')}</button>
                        )*/}
                    </div>
                </div>
          )}
          <div className='text-gray-800'>
            <button type="button" onClick={() => {setAddedType("user");setShowAddUser(true);}} className='flex items-center gap-2 disabled:opacity-25' disabled={currentTask?.status?.phase === "closing" && currentTask?.status?.transition_type === "final_auto"}>
                <i className='pi pi-plus mr-2 px-1' style={{fontSize:"1.5rem"}}></i>{t('ServiceTaskDetail.AddUser')}
            </button>
          </div>
          </div>
        </div>
    </div>
</div>
<Dialog header={t('ServiceTaskDetail.TicketDetail')} visible={showDetail} style={{ width: '70vw' }} onHide={() => setShowDetail(false)}>
    <form onSubmit={formikTask.handleSubmit}>
                <div className='w-auto flex flex-col'>
                        <div className='mb-2'>
                            <label className='font-semibold text-sm'>{t('ServiceTaskDetail.Name')}:</label>
                            <input name='theme' required disabled={!formServiceTask || Number(formServiceTask?.contractor_id) !== Number(user?.id) || checkIfTaskIsCLosed(formServiceTask)} value={formikTask.values.theme} onChange={formikTask.handleChange} className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div className='mb-2'>
                            <label className='font-semibold  text-sm'>{t('ServiceTaskDetail.Description')}:</label>
                            {(Number(formServiceTask?.contractor_id) === Number(user?.id) && isApprovalInProgress((state?.service_states ?? []).find(s => Number(s.id) === Number(formServiceTask?.status_id)))) ? <MyEditor editorValue={formikTask.values?.description} autofocus={true} fileAccept="*" formik={formikTask}/>
                            :<MyEditor editorValue={formikTask.values?.description} hideToolbar={true} hideFileUpload={true} formik={null} />}
                        </div>
                        <div className='mb-2'>
                        {["Info","Emergency"].includes(currentTask?.type) && <><label className='font-semibold  text-sm'>{t('ServiceTaskDetail.SendingTimeSetup')}:</label>
                        <select 
                        disabled
                        name="sending_option"
                        value={currentTask?.sending_option}
                        className='bg-white block w-full  px-4 py-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="immediately">{t('ServiceTaskDetail.SendImmediately')}{["Info"].includes(currentTask?.type) && ` ${t('ServiceTaskDetail.AfterApproval')}`}</option>
                            <option value="once">{t('ServiceTaskDetail.SetDateTime')}</option>
                            {["Info"].includes(currentTask?.type) && <option value="repeat">{t('ServiceTaskDetail.Repeat')}</option>}
                        </select></>}
                        {currentTask?.sending_option === "once" &&<div className='mb-3'>
                            <label className='font-semibold text-sm'>{t('ServiceTaskDetail.SendingDate')}</label>
                        <input
                            name='sending_date'
                            type="date"
                            readOnly value={currentTask?.sending_date}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        <label
                            for="sending_time"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('ServiceTaskDetail.SendingTime')}
                        </label>
                        <input
                            name='sending_time'
                            type="time" step="3600"
                            min="05:00" max="22:00"
                            readonly value={currentTask?.sending_time}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>}
                        {currentTask?.sending_option === "repeat" && <div className='mb-3'>
                        <label
                            htmlFor="regularity"
                            className="block text-sm font-semibold text-gray-800"
                        >
                            {t('ServiceTaskDetail.Schedule')}
                        </label>
                        <select 
                        readOnly
                        name='regularity' required
                        value={parseSendingData()?.regularity}
                        className={`bg-white block w-full  px-4 py-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                            <option value="">{t('Common.SelectOption')}</option>
                            <option value="Denne">{t('ServiceTaskDetail.Daily')}</option>
                            <option value="Týždenne">{t('ServiceTaskDetail.Weekly')}</option>
                            <option value="Mesačne">{t('ServiceTaskDetail.Monthly')}</option>
                        </select>
                        </div>}
                        {parseSendingData()?.regularity === 'Mesačne' && currentTask?.sending_option === "repeat" && <div className='mb-3'>
                        <label
                            htmlFor="time_period"
                            className="block text-sm font-semibold text-gray-800"
                        >
                            {t('ServiceTaskDetail.Regularity')}
                        </label>
                        <MultiSelect
                            value={(() => {
                                try {
                                    const raw = formServiceTask?.sending_data;
                                    if (!raw || raw === "undefined" || typeof raw !== 'string') return [];
                                    const parsed = JSON.parse(raw);
                                    return parsed?.time_period?.map(tp => ({ name: tp.name })) || [];
                                } catch {
                                    return [];
                                }
                            })()}
                            options={monthTimePeriod} optionLabel="name" filter placeholder={t('ServiceTaskDetail.SelectRegularity')} disabled
                            className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>}
                        {parseSendingData()?.regularity === 'Týždenne' && currentTask?.sending_option === "repeat" && <div className='mb-3'>
                        <label
                            htmlFor="time_period"
                            className="block text-sm font-semibold text-gray-800"
                        >
                            {t('ServiceTaskDetail.Regularity')}
                        </label>
                        <MultiSelect disabled 
                        value={(() => {
                                try {
                                    const raw = formServiceTask?.sending_data;
                                    if (!raw || raw === "undefined" || typeof raw !== 'string') return [];
                                    const parsed = JSON.parse(raw);
                                    return parsed?.time_period?.map(tp => ({ name: tp.name })) || [];
                                } catch {
                                    return [];
                                }
                            })()}
                            options={weekTimePeriod} optionLabel="name"
                            filter placeholder={t('ServiceTaskDetail.SelectRegularity')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>}
                        </div>
                        <div className='mb-2'>
                           {["Info","Error","Task","TechChange","Permission","Need","Borrow"].includes(currentTask?.type) && <><label className='font-semibold  text-sm'>{t('ServiceTaskDetail.TicketAssignee')}:</label>
                            <input
                            name='sender_id'
                            type="text"
                            readonly value={(state?.employees ?? []).filter(employee => Number(employee.id) === Number(currentTask?.sender_id))[0]?.name}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                            </>}
                        </div>
                        <div className='mb-2'>
                        {["Info"].includes(currentTask?.type) && <> <label className='font-semibold  text-sm'>{t('ServiceTaskDetail.InfoRecipients')}:</label>
                           <div>
                            <label
                                htmlFor="recipientDepartment"
                                className="block text-md font-semibold text-gray-800"
                            >
                                {t('ServiceTaskDetail.Departments')}
                            </label>
                            <Chips value={currentTask?.recipientDepartments?.map((department) => department.name)} disabled className={` px-4 py-2 opacity-100 h-full `}/>
                            {/*<MultiSelect disabled value={(currentTask?.departments ?? []).map((department) => 
                                    ({name:department.name,id:department.id})
                                )} 
                                options={(state?.departments ?? []).map((department) => 
                                    ({name:department.name,id:department.id})
                                )} 
                                optionLabel="name"
                                filter placeholder={t('Common.SelectDepartments')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>*/}
                            </div>
                            <div >
                            <label
                                htmlFor="recipients"
                                className="block text-md font-semibold text-gray-800"
                            >
                                {t('ServiceTaskDetail.Employees')}
                            </label>
                            <Chips value={currentTask?.employees?.map((employee) => employee.name)} disabled className={` px-4 py-2 ${
                            !recipientsReadMore
                                ? 'max-h-52 opacity-100 overflow-y-hidden mb-0'
                                : 'max-h-250 opacity-100 mb-4'
                            } `}/>
                            {currentTask?.employees?.length>15 && <button type='button' className='flex justify-center items-center mt-4 w-fit h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25' onClick={() => setRecipientsReadMore(!recipientsReadMore)}>{recipientsReadMore ? t('ServiceTaskDetail.ShowLess') : t('ServiceTaskDetail.ShowMore')}</button>}
                            {/*<MultiSelect disabled value={currentTask?.employees?.map((employee) => 
                                    ({name:employee.name,id:employee.id})
                                )}  
                                options={recipients.map((employee) => 
                                    ({name:employee.name,id:employee.id})
                                )}  
                                optionLabel="name"
                                filter placeholder={t('Common.SelectEmployees')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>*/}
                            </div></>}
                            {["Info","Emergency"].includes(currentTask?.type) &&<><div className="flex justify-content-center mb-2 mt-2">
                                <label className='block text-md font-semibold text-gray-800 mr-2'>{t('Common.Email')}:</label>
                                <InputSwitch disabled checked={parseSendingData()?.email} />
                            </div>
                            <div className="flex justify-content-center">
                                <label className='block text-md font-semibold text-gray-800 mr-2'>{t('Common.SMS')}:</label>
                                <InputSwitch disabled checked={parseSendingData()?.sms} />
                            </div></>}
                        </div>
                        <div className='mb-2'>
                           {["Error","Need"].includes(currentTask?.type) && <><label className='font-semibold  text-sm'>{t('Common.Machine')}:</label>
                            {(Number(formServiceTask?.contractor_id) === Number(user?.id) || isUserApproverOrManager(formServiceTask, user)) && !checkIfTaskIsCLosed(formServiceTask) ?
                            <Dropdown required value={formikTask.values.machine_id} onChange={(e) => {formikTask.setFieldValue("machine_id",e.value);}} 
                                options={(state?.machines ?? []).map((machine) => 
                                    ({name:machine?.name,id:machine.id,searchLabel: removeDiacritics(machine?.name).toLowerCase()})
                                )} 
                                optionLabel="name"
                                filter
                                filterBy="searchLabel"
                                filterMatchMode="contains"
                                filterPlaceholder={t('Common.Search')} placeholder={t('ServiceTaskDetail.SelectMachine')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            
                            :<input
                            name='machine_id'
                            type="text"
                            readOnly
                            value={(state?.machines ?? []).filter(machine => Number(machine.id) === Number(currentTask?.machine_id))[0]?.name}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>}
                            </>}
                        </div>
                        {(Number(formServiceTask?.contractor_id) === Number(user?.id) || isUserApproverOrManager(formServiceTask, user)) && !checkIfTaskIsCLosed(formServiceTask) &&
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none disabled:opacity-25'>{t('Common.Save')}</button>}
                </div>
                </form>
            </Dialog>
            <Dialog header={addedType === "user" ? t('ServiceTaskDetail.AddUserDialogTitle') : t('ServiceTaskDetail.AddDepartmentDialogTitle')} visible={showAddUser} style={{ width: '70vw' }} onHide={() => {setShowAddUser(false);setAddedUser([]);setAddedType("");}}>
                <div className='w-auto flex flex-col'>
                {addedType === "user" ? <MultiSelect onChange={(e) => setAddedUser(e.target.value)} value={addedUser} 
                                    options={(state?.users ?? []).filter(db_user => !(formServiceTask?.mentions ?? []).map(mention => mention.id).includes(db_user.id)).map((user) => 
                                        ({name:user?.employee?.name || user?.username,id:user.id,searchLabel: removeDiacritics(user?.employee?.name || user?.username).toLowerCase()})
                                    )} 
                                    optionLabel="name"
                                    filter
                            filterBy="searchLabel"
                            filterMatchMode="contains"
                            filterPlaceholder={t('Common.Search')} placeholder={t('ServiceUsersSettings.SelectUsers')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/> : 
                <MultiSelect onChange={(e) => setAddedUser(e.target.value)} value={addedUser} 
                                    options={(state?.departments ?? []).map((department) => 
                                        ({name:department.name,id:department.id})
                                    )} 
                                    optionLabel="name"
                                    filter filterPlaceholder={t('Common.Search')} placeholder={t('ServiceTaskDetail.SelectDepartments')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>}
                </div>
                <div>
                <button type="submit" disabled={addedUser === ""} onClick={() => addUser()} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none disabled:opacity-25'>{t('Common.Save')}</button>
                </div>
            </Dialog>
            </div>
</>);
} 